var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMapEd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.052926C6.7156 0.052926 0 6.50975 0 14.4749C0 14.4749 0 14.4749 0 14.5014C0 15.2159 0.0550457 15.9304 0.165137 16.6184C0.495413 18.7618 1.3211 20.7465 2.50459 22.4666C3.02752 23.2075 3.6055 23.8955 4.26606 24.5306L7.56881 28.4206L7.87156 28.7911L15.633 38L22.4587 28.9234V28.7911H22.5688L25.844 24.4248C26.8073 23.4457 27.633 22.3607 28.2936 21.1435C29.1743 19.5028 29.7523 17.7033 29.945 15.7716C30 15.3482 30 14.8983 30 14.4485C30 14.4485 30 14.4485 30 14.422C30 6.45683 23.2844 0 15 0V0.052926Z",
    fill: "#FEB415"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2306 22C11.5883 22 10 19.6493 10 16.7442V13.6081C10 9.57673 12.6153 8 15.6796 8C19.3837 8 21 10.0734 21 12.1469C21 15.1733 17.9918 15.9183 16.6617 16.3111C16.2801 16.4266 14.8714 16.8597 14.5515 16.9521C13.3112 17.3218 12.952 17.7376 12.952 18.2054C12.952 19.0083 13.6311 19.7533 15.225 19.7533C16.6112 19.7533 17.6214 19.2682 17.7898 17.7781H20.6913C20.3939 20.1345 19.0133 21.9942 15.225 21.9942L15.2306 22ZM15.5617 10.2467C13.951 10.2467 12.8959 11.3556 12.8959 13.2442V15.2252C12.8959 15.2252 15.0735 14.5726 15.9827 14.2838C16.7459 14.047 18.1097 13.5503 18.1097 12.3086C18.1097 11.2285 17.2622 10.2409 15.5617 10.2409V10.2467Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapEd);
export default __webpack_public_path__ + "static/media/icon_map_ed.d342d55168158a29a3112edd4d7ad2d5.svg";
export { ForwardRef as ReactComponent };